export default __webpack_public_path__ + "static/media/ic_alert.aef2f00b.svg";